import { Components, Theme } from '@mui/material';

export const MuiDrawer: Components<Theme>['MuiDrawer'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '.MuiBackdrop-root': { backgroundColor: theme.palette.background.overlay },
    }),
    paper: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          backgroundColor: theme.palette.background.default,
        };
      }

      const backgroundStyle =
        theme.palette.mode === 'light'
          ? {}
          : {
              backgroundImage: 'unset',
              backgroundColor: theme.palette.designSystem.grey[900],
            };

      return {
        ...backgroundStyle,
      };
    },
  },
};
